import React from 'react';
import img from '../../images/download.jpg'

const NotFound = () => {
    return (
        <div className="mt-5 pt-5">
            <img src={img} alt="" />
        </div>
    );
};

export default NotFound;